import type { FC } from 'react';
import { cx } from '../../../utils/cx';
import styles from './BulkSwitch.module.scss';

export type BulkState = 'on' | 'off' | 'mixed';

interface BulkSwitchProps {
    label: string;
    state: BulkState;
    disabled?: boolean;
    onChange: (value: boolean) => void;
}

export const BulkSwitch: FC<BulkSwitchProps> = ({ label, state, disabled, onChange }) => (
    <label className={cx(styles.bulk, disabled && styles.disabled)}>
        <button
            type="button"
            role="switch"
            className={styles.sw}
            aria-checked={state === 'mixed' ? 'mixed' : state === 'on'}
            disabled={disabled}
            onClick={() => onChange(state !== 'on')}
        />
        <span className={styles.label}>{label}</span>
    </label>
);